import { PropsWithChildren, useCallback, useContext, useEffect } from 'react';
import { ToDoBundleContext } from './context';

interface TodoCacheProps {
  storeId: string;
  externalBuyerId: string;
  values: any;
  visible?: boolean; // visible才记录cache
}

const Cache = new Map<string, any>(); // 不用考虑内存泄漏，这种情况很少
export const getTodoCache = (storeId: string, externalBuyerId: string) => {
  const key = createKey(storeId, externalBuyerId);
  return Cache.get(key);
};

export const clearTodoCache = (key: string) => {
  Cache.delete(key);
};

export const useClearTodoCache = () => {
  const { storeId, externalBuyerId } = useContext(ToDoBundleContext);
  return useCallback(() => {
    const key = createKey(storeId, externalBuyerId);
    clearTodoCache(key);
  }, [storeId, externalBuyerId]);
};

export const createKey = (storeId: string, externalBuyerId: string) => {
  return `${storeId}-${externalBuyerId}`;
};
export const TodoCache = (props: PropsWithChildren<TodoCacheProps>) => {
  const key = createKey(props.storeId, props.externalBuyerId);

  useEffect(() => {
    if (props.values && props.visible) {
      Cache.set(key, props.values);
    }
  }, [props.values, key, props.visible]);

  return null;
};

TodoCache.displayName = 'TodoCache';
